/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { TaxNumber } from '../types/taxNumber.types';
import EIN from './EIN';
import CheckVatNumber from './CheckVatNumber';

const TaxNumberField = ({
  taxNumberType, findCompany, form, view, setDisabledCountrySelect,
}) => {
  switch (taxNumberType) {
    case TaxNumber.EIN:
      return (<EIN />);
    case TaxNumber.VAT:
    default:
      return (
        <CheckVatNumber
          findCompany={findCompany}
          form={form}
          view={view}
          setDisabledCountrySelect={setDisabledCountrySelect}
        />
      );
  }
};

TaxNumberField.propTypes = {
  taxNumberType: PropTypes.oneOf(Object.values(TaxNumber)).isRequired,
  findCompany: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired,
  view: PropTypes.any.isRequired,
  setDisabledCountrySelect: PropTypes.func.isRequired,
};

TaxNumberField.defaultProps = {
};

export default TaxNumberField;
